var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"orange","small":""},on:{"click":_vm.updateData}},[_vm._v("mdi-pencil ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }